import { BTMenu } from "@btnet/core-components/BTMenu";

import { BTIconLinkOutlined } from "commonComponents/btWrappers/BTIcon";
import {
    canOpenLinkEdit,
    isSelectionExclusivelyInTitle,
} from "commonComponents/btWrappers/editor/core/editor.utils";
import { type ICollapsableControl } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/CollapsableControlGroup/CollapsableControlGroup";
import { EditorControlButton } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/EditorControlButton/EditorControlButton";
import { InputRecaptureHackMenuItem } from "commonComponents/btWrappers/editor/core/EditorControlBar/common/InputRecaptureHack/InputRecaptureHack";
import { type ExtensionName } from "commonComponents/btWrappers/editor/core/extensions/editorExtensionUtils";
import { type IEditor } from "commonComponents/btWrappers/editor/core/useBTEditor.types";

const extensionId = "link";
const friendlyName = "Link";
const icon = <BTIconLinkOutlined />;
const onClick = (editor: IEditor) => {
    editor.editorStateDispatch({ type: "setShowLinkEditorOverlay", payload: true });
};

export const linkControl: ICollapsableControl = {
    key: extensionId,
    isControlSupported(supportedExtensions: Set<ExtensionName>) {
        return supportedExtensions.has(extensionId);
    },
    isControlEnabled({ tiptapEditor }) {
        return (
            canOpenLinkEdit(tiptapEditor) &&
            !isSelectionExclusivelyInTitle(tiptapEditor, tiptapEditor.state.selection)
        );
    },
    expandedElement(editor) {
        return (
            <EditorControlButton
                friendlyName={friendlyName}
                data-testid="linkControl"
                icon={icon}
                isToggled={editor.tiptapEditor.isActive(extensionId)}
                onClick={() => onClick(editor)}
                disabled={!this.isControlEnabled(editor)}
            />
        );
    },
    collapsedActiveKeys({ tiptapEditor }) {
        return tiptapEditor.isActive(extensionId) ? [extensionId] : [];
    },
    collapsedMenuItem(editor) {
        return (
            <InputRecaptureHackMenuItem
                editor={editor}
                menuComponent={BTMenu.Item}
                menuProps={{
                    testid: this.key,
                    onClick: () => onClick(editor),
                    className: "btEditorControlBarMenuItem",
                    icon,
                    disabled: !this.isControlEnabled(editor),
                }}
                key={this.key}
            >
                {friendlyName}
            </InputRecaptureHackMenuItem>
        );
    },
};
export default linkControl;
